import React, { useState } from 'react';
import './AdminLogin.css';

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [selectedRole, setSelectedRole] = useState('admin');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Decode function for security (credentials stored encoded)
  const decode = (str) => atob(str);

  // Secure credentials (Base64 encoded to prevent direct visibility)
  // admin: CPL@a2ztak99, manager: manager@99
  const credentials = {
    admin: {
      username: 'admin',
      password: decode('Q1BMQGEyenRhazk5'), // CPL@a2ztak99
      role: 'admin',
      name: 'Administrator'
    },
    manager: {
      username: 'manager',
      password: decode('bWFuYWdlckA5OQ=='), // manager@99
      role: 'manager',
      name: 'Sales Manager'
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    setTimeout(() => {
      const user = credentials[selectedRole];
      
      if (username === user.username && password === user.password) {
        const userData = {
          username: user.username,
          role: user.role,
          name: user.name,
          loginTime: new Date().toISOString()
        };
        
        localStorage.setItem('adminUser', JSON.stringify(userData));
        onLogin(userData);
      } else {
        setError('Invalid username or password!');
        setLoading(false);
      }
    }, 500);
  };

  return (
    <div className="admin-login-container">
      <div className="login-box">
        <div className="login-header">
          <h2>🔐 A2zTak Admin</h2>
          <p>Welcome back! Please login to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="role-selection">
            <label className={`role-card ${selectedRole === 'admin' ? 'active' : ''}`}>
              <input
                type="radio"
                name="role"
                value="admin"
                checked={selectedRole === 'admin'}
                onChange={(e) => setSelectedRole(e.target.value)}
              />
              <div className="role-content">
                <i className="bi bi-shield-check"></i>
                <h4>Admin</h4>
                <p>Full Access</p>
              </div>
            </label>

            <label className={`role-card ${selectedRole === 'manager' ? 'active' : ''}`}>
              <input
                type="radio"
                name="role"
                value="manager"
                checked={selectedRole === 'manager'}
                onChange={(e) => setSelectedRole(e.target.value)}
              />
              <div className="role-content">
                <i className="bi bi-person-badge"></i>
                <h4>Sales Manager</h4>
                <p>Sales & Customer</p>
              </div>
            </label>
          </div>

          <div className="form-group">
            <label htmlFor="username">
              <i className="bi bi-person"></i> Username
            </label>
            <input
              type="text"
              id="username"
              className="form-control"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <i className="bi bi-lock"></i> Password
            </label>
            <input
              type="password"
              id="password"
              className="form-control"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              <i className="bi bi-exclamation-triangle"></i> {error}
            </div>
          )}

          <button 
            type="submit" 
            className="btn btn-primary btn-login"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Logging in...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right"></i> Login
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <small>© 2025 A2zTak. All rights reserved.</small>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
